import { Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MaterialTable from "material-table";
import LabelsContext from "../../../lang/LabelsContext";
import EnumSeniority from "../../../utils/enum/EnumSeniority";
import { tableIcons } from "../../system/material-table-utils/MaterialTableUtils";
import AddReviewer from "../add-reviewer/AddReviewer";
import ReviewersStatisticsService, { ReviewersStatisticsServiceType } from "./ReviewersStatisticsService";
import useStyles from "./ReviewersStatisticsStyle";

export default function ReviewersStatistics() {
  const classes = useStyles();
  const { Labels } = LabelsContext();
  const {
    value,
    handleChange,
    reviewerList,
    getReviewersStatisticsList,
    saveReviewer,
  }: ReviewersStatisticsServiceType = ReviewersStatisticsService();

  return (
    <>
      <CssBaseline />
      <Paper className={classes.paper}>
        <Typography component="h1" variant="h4" align="center">
          {Labels.REVIEWERS_STATISTICS}
        </Typography>
        <Grid container spacing={1} justifyContent="space-between">
          <Grid item>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <TextField
                  variant="outlined"
                  margin="normal"
                  name="dateFrom"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={classes.textField}
                  value={value.dateFrom}
                  onChange={handleChange}
                  label={Labels.DATE_FROM}
                  fullWidth
                />
              </Grid>
              <Grid item>
                <TextField
                  variant="outlined"
                  margin="normal"
                  name="dateTo"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={classes.textField}
                  value={value.dateTo}
                  onChange={handleChange}
                  label={Labels.DATE_TO}
                  fullWidth
                />
              </Grid>
              <Grid item>
                <Button onClick={getReviewersStatisticsList} variant="contained" color="primary">
                  {Labels.SEARCH}
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <AddReviewer save={saveReviewer} label={Labels.ADD_REVIEWER} />
          </Grid>
        </Grid>
      </Paper>
      <MaterialTable
        icons={tableIcons}
        columns={[
          { field: "lastName", title: Labels.LASTNAME },
          { field: "firstName", title: Labels.FIRSTNAME },
          {
            field: "seniority.level",
            title: Labels.SENIORITY,
            render: (rowData: any) => <div>{rowData.seniority ? rowData.seniority.level : EnumSeniority.SENIOR}</div>,
          },
          {
            field: "expertise",
            sorting: true,
            title: Labels.AREAS_OF_EXPERTISE,
            cellStyle: { width: "25%" },

            render: (rowData) => (
              <Tooltip title={<h3>{rowData.expertise}</h3>}>
                <span>
                  {rowData.expertise.length > 100 ? `${rowData.expertise.substring(0, 100)}...` : rowData.expertise}
                </span>
              </Tooltip>
            ),
          },
          { field: "responseTime", title: Labels.RESPONSE_TIME_DAYS },
          { field: "accepted", title: Labels.ACCEPTED, defaultSort: "desc" },
          { field: "completed", title: Labels.COMPLETED },
          { field: "refused", title: Labels.REFUSED },
          {
            field: "refusedPct",
            title: Labels.REFUSED_PERCENTAGE,
            render: (rowData: any) => (
              <div>{rowData.refusedPct ? (parseFloat(rowData.refusedPct) * 100).toFixed(2) : ""}</div>
            ),
          },
          {
            field: "acceptedArticles",
            title: Labels.PUBLISHED_LAST_36_MONTHS,
          },
          {
            field: "avgRating",
            title: Labels.RATING,
            render: (rowData: any) => <div>{rowData.avgRating ? parseFloat(rowData.avgRating).toFixed(2) : ""}</div>,
          },
        ]}
        title={Labels.REVIEWERS_STATISTICS}
        data={reviewerList}
        options={{
          actionsColumnIndex: -1,
          pageSize: 10,
          exportAllData: true,
          exportButton: {
            csv: true,
            pdf: true,
          },
        }}
      />
    </>
  );
}
